import { useCallback } from "react";
import { Button } from "@shopify/polaris";
import { GettingStartedStoreAccess } from "../../../../libs/store";
import { useToast } from "@vendor-app/app/_sharedComponents/Toast/ToastProvider";
import { useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";

interface SelectProductsButtonProps {
  setShowProductOptionsModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SelectProductsButton = ({ setShowProductOptionsModal }: SelectProductsButtonProps) => {
  const setup = GettingStartedStoreAccess.useSetup();
  const sellingPlanGroup = GettingStartedStoreAccess.useSellingPlanGroup();
  const {
    purchasables,
    isLoading: isPurchasablesLoading,
    isLoadingAdditionaly: isPurchasablesLoadingAdditionaly,
  } = useSmartrrVendorSelector(state => state.purchasables);

  const { addToast } = useToast();
  const onAddProductsAndVariantsClick = useCallback(async () => {
    if (setup?.selectedSellingPlanId) {
      setShowProductOptionsModal(true);
    } else {
      addToast("Create a subscription program first");
    }
  }, [setup?.selectedSellingPlanId, sellingPlanGroup.productIds, sellingPlanGroup.variantIds]);

  const purchasablesLoading = isPurchasablesLoading || isPurchasablesLoadingAdditionaly;

  return (
    <Button
      loading={purchasablesLoading}
      primary
      onClick={onAddProductsAndVariantsClick}
      disabled={!purchasables.length || !setup?.selectedSellingPlanId}
    >
      Select from existing products
    </Button>
  );
};
